import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ServicesPage from "@/pages/ServicesPage";

export const Route = createFileRoute("/services")({
  head: () => pageHead("AI Services", "Comprehensive AI services including machine learning, multi-agent systems, MLOps, data engineering, and enterprise IT for government and commercial clients.", "/services", false),
  component: ServicesPage,
});
